import { Tooltip as RechartsTooltip } from 'recharts';

export const ChartTooltip = (
    props: React.ComponentProps<typeof RechartsTooltip>
) => {
    return <RechartsTooltip data-testid={'ChartTooltip-container'} {...props} />;
};

export default ChartTooltip;
